import LogoL from './images/logo.png'
import Entrance from './images/backdrops/entrance.jpg'
import EntranceM from './images/backdrops/entrancePortrait.jpg'
import LobbyM from './images/backdrops/lobbyM.png'
import LobbyL from './images/backdrops/lobby.jpg'
import Exhibition from './images/backdrops/exhibition-hall.jpg'
import Auditorium from './images/backdrops/auditorium.jpg'
import AuditoriumM from './images/backdrops/auditoriumM.jpg'
import MC from './images/backdrops/MC20.png'
import NetworkingL from './images/backdrops/networking.jpg'
import NetworkingM from './images/backdrops/networkingM.jpg'
import LobbyMusic from './images/audio/lobby.mp3'
import routes from './routes'
import Gallerium from './images/backdrops/gallerium.jpg'
import BoothBg from './images/backdrops/booth-bg.jpg'
import Sponsors from './images/Sponsors-banner.png'

const dev = {
  apiUrl: 'http://localhost:3000',
}

const prod = {
  apiUrl: 'https://namaseanaaa2021.com/',

}

const API_KEYS = {
  amplitude: '97a9de30cde6be1b72e42e4a9ebeba07',
}

const VOLUME_VALUE = 1

const config = process.env.NODE_ENV === 'production' ? prod : dev

const assets = {
  sponsors: {
    landscape: Sponsors,
    portrait: Sponsors,
  },

  booth: {
    landscape: BoothBg,
  },

  logo: {
    landscape: LogoL,
    portrait: LogoL,
  },
  entrance: {
    landscape: Entrance,
    portrait: EntranceM,
  },
  lobby: {
    landscape: LobbyL,
    portrait: LobbyM,
  },
  auditorium1: {
    landscape: Auditorium,
    portrait: AuditoriumM,
  },
  auditorium2: MC,

  exhibition1: Exhibition,
  exhibition2: Exhibition,

  networking: {
    landscape: NetworkingL,
    portrait: NetworkingM,
  },
  gallerium: Gallerium,

  lobbyMusic: LobbyMusic,
}

const layout = {
  auditoriumVid: `
    top: 13%;
    bottom: 40.5%;
    left: 20.5%;
    right: 35.2%;
  `,
}

const lobbyEntries = [
  {
    id: 'auditorium',
    destination: routes.auditorium1,
    // destination: [
    //   { name: 'KFAIR20', url: routes.auditorium1 },
    //   { name: 'MC20', url: routes.auditorium2 },
    // ],
    css: `
      top: 54.4%;
      left: 43.2%;
      right: 50%;
      bottom: 30.2%;
    `,
  },
  {
    id: 'exhibition',
    // destination: routes.exhibition1,
    destination: [
      { name: 'Hall A', url: routes.exhibition1 },
      { name: 'Hall B', url: routes.exhibition2 },
    ],
    css: `
      top: 80%;
      left: 37%;
      right: 58%;
      bottom: 20.5%;
    `,
  },
  {
    id: 'networking',
    destination: routes.networking,
    css: `
      top: 54.4%;
      left: 31.5%;
      right: 61.9%;
      bottom: 30.2%;
    `,
  },
  {
    id: 'gallerium',
    destination: routes.onDemand,
    css: `
      top: 40.4%;
      left: 62.7%;
      right: 22.4%;
      bottom: 43%;
      opacity: 0;
    `,
  },
  {
    id: 'gallerium',
    destination: routes.masterclass,
    css: `
      top: 54.4%;
      left: 55%;
      right: 38.2%;
      bottom: 30.2%;
    `,
  },
  {
    id: 'booth',
    destination: routes.brainlabBooth,
    css: `
      top: 0.5%;
      left: 12%;
      right: 81%;
      bottom: 62%;
      opacity: 0;
    `,
  },
  {
    id: 'booth',
    destination: routes.medtronicBooth,
    css: `
      top: 7%;
      left: 20%;
      right: 73.9%;
      bottom: 61%;
      opacity: 0;
    `,
  },
  {
    id: 'booth',
    destination: routes.zeissBooth,
    css: `
      top: 14%;
      left: 27%;
      right: 67.5%;
      bottom: 59%;
      opacity: 0;
    `,
  },
  {
    id: 'helpdesk',
    destination: 0,
    css: `
      top: 75.5%;
      left: 50.5%;
      right: 0.5%;
      bottom: 24.5%;
    `,
  },
]

export default {
  API_KEYS,
  assets,
  layout,
  lobbyEntries,
  VOLUME_VALUE,

  eventName: '19th ASEAN NS / Inaugural AAA',

  ...config,
}
